export const useMutationOptions = <TOptions>(options: TOptions): TOptions => {
  return {
    networkMode: "always",
    ...options,
  } as const
}
